import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Modal from "../Simple/Modal";
import CloseButton from "../Simple/CloseButton";
import ActionBar from "../Simple/ActionBar";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ApplicationStepper from "./components/ApplicationStepper";
import Application from "./Application";
import Hidden from '@material-ui/core/Hidden';
import Actions from "./components/Actions";
import Loader from "../Simple/Loader";
import {getApplication} from '../../api'


const styles = theme => ({
    container: {
        padding: theme.spacing(0),
        [theme.breakpoints.up(450)]: {
            padding: theme.spacing(2) + 'px ' + theme.spacing(2) + 'px ' + theme.spacing(1) + 'px ' + theme.spacing(2) + 'px ',
        }
    },
    actionBarRoot: {
        padding: theme.spacing(1) + 'px ' + theme.spacing(1) + 'px 0 ' + theme.spacing(1) + 'px ',
        maxWidth: 1466,
        margin: 'auto',
        [theme.breakpoints.up(450)]: {
            padding: theme.spacing(1) + 'px ' + theme.spacing(3) + 'px 0 ' + theme.spacing(4) + 'px ',
        }
    },
    button: {
        margin: '0 ' + theme.spacing(1) + 'px',
        marginBottom: theme.spacing(1) + 'px ',
    },
    acceptButton: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    iconButton: {
        fontSize: '1.14rem',
        minWidth: 0,
    },
    rejectButton: {
        borderColor: '#f44336',
        color: '#f44336',
    },
    hideOnMobile: {
        display: 'none',
        [theme.breakpoints.up(800)]: {
            display: 'inline',
        }
    },
    hideOnSmallMobile: {
        display: 'none',
        [theme.breakpoints.up(450)]: {
            display: 'inline',
        }
    },
    leftIcon: {
        height: '1.5rem',
        [theme.breakpoints.up(800)]: {
            marginRight: 10,
            marginLeft: -3,
        }
    },
    smallTextLeftIcon: {
        [theme.breakpoints.up(450)]: {
            marginRight: 10,
            marginLeft: -3,
        }
    },
    smallPadding: {
        [theme.breakpoints.down(450)]: {
            paddingTop: '12px!important',
        }
    },
    smallPaddingBottom: {
        [theme.breakpoints.down(450)]: {
            paddingBottom: '21px!important',
        }
    }
});

class ApplicationModal extends PureComponent {
    state = {
        application: null,
        initLoading: true,
        refreshLoading: false,
        user: null,
    };

    componentDidMount() {
        this.onRefresh()
    }

    onRefresh = () => {
        this.setState({refreshLoading: !this.state.initLoading})
        const id = this.props.id
        return getApplication(id).then(response => {
            const data = response.data
            this.setState({application: data.application, user: data.user, initLoading: false, refreshLoading: false})
            this.forceUpdate()
        })
    }

    render() {
        const {classes, children, toggle} = this.props;
        const {application, initLoading, refreshLoading, user} = this.state;

        const actions = application ? application.actions : []

        return (
            <>
                <Modal onOutsideAction={toggle} key="modal" style={{overflow: 'auto', background: '#f3f3f3'}}>
                    {initLoading && <div className="loader-wrapper my-5">
                        <Loader/>
                    </div>}
                    {!initLoading && application && <>
                        <Hidden smDown>
                            <Grid container className={classes.container} style={{paddingBottom: 16}}>
                                <Grid item sm={2}>
                                    <Typography
                                        style={{fontSize: '0.8rem', marginTop: -6}}>{application.createdAt}</Typography>
                                    <Typography><b>{application.client.name}</b></Typography>
                                </Grid>
                                <Grid item sm={8} style={{paddingTop: 0}}>
                                    {application.stepper && <ApplicationStepper stepper={application.stepper}
                                                                                activeStep={application.stepper.activeStep}/>}
                                </Grid>
                                <CloseButton onClick={toggle}/>
                            </Grid>
                        </Hidden>
                        <Hidden mdUp>
                            <Grid container className={classes.container}>
                                <Grid item sm={12} style={{marginTop: 2, padding: '2px 12px'}}
                                      className={classes.smallPadding}>
                                    <Typography
                                        style={{fontSize: '0.8rem', marginTop: -6}}>{application.createdAt}&nbsp;
                                        <b>{application.client.name}</b></Typography>
                                </Grid>
                                <Grid item sm={12} style={{padding: '7px 6px 16px'}}
                                      className={classes.smallPaddingBottom}>
                                    {application.stepper && <ApplicationStepper stepper={application.stepper}
                                                                                activeStep={application.stepper.activeStep}/>}
                                </Grid>
                                <CloseButton onClick={toggle}/>
                            </Grid>
                        </Hidden>
                        <Grid container className={classes.container} style={{paddingTop: 0, marginTop: -8}}>
                            <Application application={application} refresh={this.onRefresh} user={user}/>
                        </Grid>
                    </>}
                    <ActionBar>
                        <Actions actions={actions} refresh={this.onRefresh} isLoading={refreshLoading}
                                 application={application}/>
                    </ActionBar>
                </Modal>
            </>
        )
    }
}

ApplicationModal.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ApplicationModal);
